export default "__VITE_ASSET__DBH9SG$i__"